<div class="player" [class.has-formation]="hasFormation && !isSubstitute" [class.home-and-away]="!hasFormation && !isSubstitute" [class.away-substitutes]="isAway && isSubstitute" [class.no-border]="noBorder">
  <div *ngIf="isAway && isSubstitute" class="name" [ngStyle]="{'font-size': (isMobile) ? '9px' : '14px'}">
    <span *ngIf="playerImgAvailable && player.number">{{ player.number.toString() }} |&nbsp;</span><span>{{player.getName(false)}}</span>
  </div>
  <div class="activities-wrapper">
    <div class="number" [class.image]="playerImgAvailable"
         [ngStyle]="{'background-image': 'url(\'' + playerImgUrl + '\')'}">
      <div *ngIf="!playerImgAvailable" class="player-number" [ngStyle]="{'background-color': bgColor, 'color': fontColor}">{{player.getNumberOrInitials()}}</div>
    </div>
    <div class="goalCounter" *ngIf="goalCounter > 1">
      {{goalCounter}}x &nbsp;
    </div>
    <img *ngIf="hasGoalActivity"
         alt="Goal Icon"
         class="goal"
         src="assets/icons/live-ticker/players/pi-goal.svg" />
    <img *ngIf="hasCardActivity === 'red'"
         class="red-card"
         src="assets/icons/live-ticker/players/pi-red-card.svg" />
    <img *ngIf="hasCardActivity === 'yellow'"
         class="yellow-card"
         src="assets/icons/live-ticker/players/pi-yellow-card.svg" />
    <img *ngIf="hasCardActivity === 'yellow-red'"
         class="red-yellow-card"
         src="assets/icons/live-ticker/players/pi-red-yellow.svg" />
    <img *ngIf="hasSubstitutionInActivity"
         class="substitution"
         src="assets/icons/live-ticker/players/pi-substitution-in.svg" />
    <img *ngIf="hasSubstitutionOutActivity"
         class="substitution"
         src="assets/icons/live-ticker/players/pi-substitution-out.svg" />
  </div>
  <div *ngIf="!isSubstitute" class="name" [ngStyle]="{'font-size': (isMobile) ? '9px' : '14px'}">
    <span *ngIf="playerImgAvailable && player.number">{{ player.number.toString() }} |&nbsp;</span><span>{{player.getName(false)}}</span>
  </div>
</div>
